import React, { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

/**
 * Emergent Auth callback handler.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const processCallback = useCallback(async () => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      const { data } = await api.post("/auth/session", { session_id: sessionId });
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/admin", { replace: true, state: { user: data.user } });
    } catch (err) {
      const msg = err?.response?.data?.detail || "No se pudo iniciar sesión.";
      navigate("/login", { replace: true, state: { error: msg } });
    }
  }, [navigate]);

  useEffect(() => {
    processCallback();
  }, [processCallback]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <Loader2 className="h-8 w-8 animate-spin text-[#04b0ba]" />
      <p className="mt-4 text-sm text-[#666666]">Autenticando...</p>
    </div>
  );
}
